"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcButton = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("react-bootstrap/Button"));
exports.AcButton = react_1.forwardRef(function (_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? 'main' : _b, onClick = _a.onClick, className = _a.className, children = _a.children, _c = _a.size, size = _c === void 0 ? 'md' : _c, disabled = _a.disabled, height = _a.height, width = _a.width, tabIndex = _a.tabIndex, label = _a.label, _d = _a.type, type = _d === void 0 ? 'button' : _d, active = _a.active, rest = __rest(_a, ["variant", "onClick", "className", "children", "size", "disabled", "height", "width", "tabIndex", "label", "type", "active"]);
    var btnVariant = variant;
    var renderStyle = function () {
        var styles = {};
        if (width) {
            if (("" + width).endsWith('%')) {
                styles.width = "" + width;
            }
            else {
                styles.width = width + "px";
            }
        }
        if (height) {
            if (("" + height).endsWith('%')) {
                styles.height = "" + height;
            }
            else {
                styles.height = height + "px";
            }
        }
        return styles;
    };
    return (react_1.default.createElement(Button_1.default, __assign({ ref: ref }, rest, { active: active, variant: btnVariant, size: size, disabled: disabled, type: type, className: className, onClick: onClick, style: renderStyle(), tabIndex: tabIndex }), label !== null && label !== void 0 ? label : children));
});
exports.AcButton.displayName = 'AcButton';
//# sourceMappingURL=AcButton.js.map